export default "__VITE_ASSET__DQsgil$M__"